module.exports = __webpack_public_path__ + "img/gallery.7392fcee.svg";